import api from '@/api/axios';
import Swal from "sweetalert2";

/**
 * Verifica no backend se existem declarações/documentos ativos para assinatura.
 * GET /existeDeclaracaoAssinaturaCliente
 * O backend resolve o clienteId a partir da autenticação.
 *
 * Retorna: true se existe ativo; false caso contrário.
 */
export async function verificarDocumentoAtivo({ silent = true, timeout = 15000 } = {}) {
  try {
    const resp = await api.get("/declaracao/existeDeclaracaoAssinaturaCliente", { timeout });
    const payload = resp?.data;

    // Normaliza possíveis formatos de resposta
    if (typeof payload === "boolean") return payload;
    if (typeof payload?.data === "boolean") return payload.data;
    if (typeof payload?.Data === "boolean") return payload.Data;

    // fallback seguro
    return false;
  } catch (error) {
    if (!silent) {
      const msg =
        error?.response?.data?.descricao ??
        error?.response?.data?.Descricao ??
        error?.response?.data?.message ??
        error?.message ??
        "Falha ao verificar documentos ativos.";
      await Swal.fire({ icon: "error", title: "Erro na verificação", text: msg });
    }
    throw error;
  }
}
